import React, { Component } from "react";

// import { Permanent, Reports } from "../../../../imports/api/permanent";
import HeaderFolder from "./Header";
import FormFolder from "./Form";
// import ReportFolder from "./Report";

const PopupProperties = props => <div>{props.parentState.currentPageLabel}</div>;

const FormDataDisplay = props => <div>{props.parentState.pageData.length}</div>;
const ReportsTable = props => <div>{props.parentState.pageHistory}</div>;

class index extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
   
    // if (this.props.parentState.OriginalData.length > 0) {
    //   const { starting } = this.props.parentState.formElements[
    //     this.props.parentState.currentPage
    //   ];
    //   console.log(this.props.parentState)
    //   if (starting) {
    //     this.props.liftGlobalState(
    //       { name: "pageData" },
    //       this.props.parentState.fileOpenData
    //     );
    //   } else {
    //     this.props.liftGlobalState(
    //       { name: "workFlowData" },
    //       this.props.parentState.OriginalData[0]
    //     );
    //   }
    // }
  }
  handleClose=()=> {
    // console.log("filefolder close");

    const { fileFolder,formState } = this.props.parentState;
    fileFolder.isOpen = false;
    fileFolder.recordID = "";
   
    this.props.liftGlobalState({ name: "formState" }, "");
    this.props.liftGlobalState({ name: "fileFolder" }, fileFolder);
  }

  render() {
    // console.log("filefolder open");
    let { otherPage } = this.props.parentState;
    let reportData = [];
    let OriginalData = [];

    this.props.parentState.OriginalData.length > 0
      ? (OriginalData = this.props.parentState.OriginalData)
      : (OriginalData = []);
    return (
      <div
        className={`col-12 ${
          !this.props.parentState.fileFolder.isClosing
            ? "animated fadeIn"
            : "animated fadeOut"
        } `}
        style={{ padding: "0px" }}
      >
        <div className="form-section ">
          <HeaderFolder
            parentState={this.props.parentState}
            OriginalData={this.props.OriginalData}
            liftGlobalState={this.props.liftGlobalState}
            liftWrapperState={this.props.liftGlobalState}
            parentProps={this.props.parentProps}
          />

          <FormFolder
            parentState={this.props.parentState}
            liftGlobalState={this.props.liftGlobalState}
            liftState={this.props.liftState}
            parentProps={this.props.parentProps}
          />

          {/* {otherPage == "" && (
            <ReportFolder
              parentState={this.props.parentState}
              liftGlobalState={this.props.liftGlobalState}
              ReportsData={reportData}
              OriginalData={OriginalData}
              parentProps={this.props.parentProps}
            />
          )} */}
          {/* <div onClick={this.handleClose}>
        </div> */}
        </div>
      </div>
    );
  }
}

export default index

// export default withTracker(({ parentState }) => {
//   // Check if the current page is report. Then load reports data in react-table.

//   // Check if the current page is NOT report. Then load pageData data in react-table.
//   const query = { originalID: parentState.fileFolder.recordID };
//   const projection = { fields: { pageData: 1 }, sort: { createdAt: -1 } };
//   Meteor.subscribe("ReportsData", query, projection);
//   Meteor.subscribe("OriginalDataForReport", {
//     _id: parentState.fileFolder.recordID
//   });

//   return {
//     ReportsData: Reports.find(query, projection).fetch(),
//     OriginalData: Permanent.find(
//       { _id: parentState.fileFolder.recordID },
//       {
//         // fields: { pageData: 1,requestID:1,history:1 },
//         // sort: { createdAt: 1 }
//       }
//     ).fetch(),
//     status: Meteor.status()
//   };
// })(index);
